// extracted by mini-css-extract-plugin
export default {"iconWrapper":"Icon_iconWrapper__IvkVK","icon":"Icon_icon__gv8m5"};